import { Box, Flex, Icon, Text, Tooltip } from '@chakra-ui/react';
import { InputField } from './InputField';
import { useField } from 'formik';
import { useRef, useState } from 'react';
import { Edit03 } from '@kula-ai/icons/outline/Edit03';
import { XClose } from '@kula-ai/icons/outline/XClose';
import { Check } from '@kula-ai/icons/outline/Check';

export const InputInlineEdit = ({ item = {}, field }) => {
  const {
    name,
    textProps = {},
    inlineMode = 'notSwap', //swap
    additionalText,
    toolTipText,
    disabled,
  } = item;

  const [isEditing, setEditing] = useState(false);
  const inputRef = useRef();
  // eslint-disable-next-line no-unused-vars
  const [_field, meta, helpers] = useField(name);
  const { setValue } = helpers;

  const handleSave = () => {
    const val = inputRef?.current?.value;
    if (val) {
      setValue(val);
      setEditing(false);
    }
  };

  return (
    <Flex alignItems="center" gap="15px">
      <Flex alignItems="center" gap="1em" w="100%">
        <InputField
          item={{ ...item, isEditable: isEditing, inputRef }}
          field={field}
        />
        {inlineMode === 'swap' && (
          <Flex gap=".5em" mr="15em">
            <Icon
              _disabled={!inputRef?.current?.value}
              as={Check}
              color="ats-primary"
              cursor={inputRef?.current?.value ? 'pointer' : 'not-allowed'}
              onClick={handleSave}
              w="1.5em"
              h="1.5em"
            />
            <Icon
              as={XClose}
              color="ats-negative"
              cursor="pointer"
              onClick={() => setEditing(false)}
              w="1.5em"
              h="1.5em"
            />
          </Flex>
        )}
      </Flex>
      {!isEditing && !disabled && (
        <Tooltip variant="default" label={toolTipText}>
          <Box mt="10px">
            <Icon
              as={Edit03}
              cursor="pointer"
              _hover={{
                color: 'ats-primary',
              }}
              onClick={() => setEditing(true)}
            />
          </Box>
        </Tooltip>
      )}
      {additionalText && (
        <Text fontSize="sm" color="ats-text-secondary" {...textProps}>
          {additionalText}
        </Text>
      )}
    </Flex>
  );
};
